export default {
  called: 'English',
  langs: {
    'zh': 'Chiness',
    'en': 'English',
    'ja': 'Japanese'
  },
  contact: 'Contact now',
  gloaleTitle: 'Fluent in any language',
  gloaleText: 'Ready to talk confidently with the best online tutors',
  services: 'High-quality foreign teacher resources from around the world',
  serviceContent: 'Make the world your comfort zone',
  serviceItems: [{
    title: 'Immerse yourself in the new culture',
    desc: 'Connect with language experts around the world'
  }, {
    title: 'Get expert help when you need it',
    desc: 'Learn to solve any problem in any language'
  }, {
    title: 'Successful career',
    desc: 'Develop your working vocabulary and communicate clearly'
  }, {
    title: 'Always speak naturally',
    desc: 'Make a good impression and build trust in any language'
  }],
  items: [{
    title: 'Professional Tutor',
    desc: 'Find native speakers and certified private tutors'
  }, {
    title: 'Verified profile',
    desc: 'We will carefully check and confirm the personal information of each mentor'
  }, {
    title: 'Learn anytime',
    desc: 'Take online courses at the best time for your busy schedule.'
  }, {
    title: 'Affordable price',
    desc: 'Choose an experienced tutor that fits your budget'
  }],
  teachLabel: 'Online and offline, ready to talk confidently with the best foreign teachers',
  endLabel: 'One-to-one business language training for your team',
  endSmall: 'Employees can practice pronunciation or improve business language skills anytime, anywhere<br>Each tutor provides a personalized plan to help learners achieve their short-term or long-term goals and improve their business language',
  just: 'More than just learning a language',
  justval: 'Learn the skills of a lifetime with BBtalk, develop new perspectives, And connect with people from all over the world. ',
  letStart: 'start now'

}